<script lang="ts">
  import { closeModal, onBeforeClose } from "@thehood/svlib";

  export let isOpen: boolean;
  export let onCloseCallback: () => void = () => {
    // console.log("empty");
  };

  function handleClose(ev: Event) {
    ev.stopImmediatePropagation();
    onCloseCallback();
    allowClose = true;
    closeModal();
  }
  let allowClose = false;

  onBeforeClose(() => {
    return allowClose;
  });
</script>

{#if isOpen}
  <div role="dialog" class="modal">
    <div class="contents">
      <h2>Cookies on Football Ticketpad</h2>
      <div class="cookie-banner__content">
        <p class="cookie-body">We use some essential cookies to make this service work.</p>
        <p class="cookie-body">
          We’d also like to use analytics cookies so we can understand how you use the service and make improvements.
        </p>
      </div>
      <div class="actions">
        <button class="btn btn-primary" on:click={handleClose}>Accept Cookies</button>
      </div>
    </div>
  </div>
{/if}

<style>
  .modal {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    z-index: var(--z5);
    /* allow click-through to backdrop */
    pointer-events: none;
  }

  .contents {
    min-width: 240px;
    max-width: 480px;
    border-radius: 6px;
    padding: 16px;
    background-color: #f3f2f1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    pointer-events: auto;
    border: 1px solid gray;
  }

  h2 {
    font-size: 24px;
    text-align: left;
    margin-bottom: 1rem;
  }

  p {
    margin-top: 16px;
    text-align: left;
  }

  .actions {
    margin-top: 1rem;
    display: flex;
    justify-content: flex-start;
    gap: 8px;
  }
</style>
